/**
 * Portal OAuth UI flags (query → sessionStorage).
 * Survives the redirect off /portal_oauth; cleared on logout.
 */

export const PORTAL_UI_FLAGS_KEY = 'portal_ui_flags';

export const DEFAULT_PORTAL_UI_FLAGS = Object.freeze({
  isShowSidenav: true,
  isDisablePlatform: false,
});

/**
 * Parse isShowSidenav (and similar) query values.
 * Missing / unknown → true (keep existing planner chrome).
 */
export function parseBooleanQueryParam(raw, defaultValue = true) {
  if (raw == null || String(raw).trim() === '') return defaultValue;
  const v = String(raw).trim().toLowerCase();
  if (['false', '0', 'no', 'off'].includes(v)) return false;
  if (['true', '1', 'yes', 'on'].includes(v)) return true;
  return defaultValue;
}

export function normalizePortalUiFlags(partial = {}) {
  return {
    isShowSidenav: partial.isShowSidenav !== false,
    isDisablePlatform: partial.isDisablePlatform === true,
  };
}

export function readPortalUiFlags() {
  try {
    const raw = sessionStorage.getItem(PORTAL_UI_FLAGS_KEY);
    if (!raw) return { ...DEFAULT_PORTAL_UI_FLAGS };
    return normalizePortalUiFlags(JSON.parse(raw));
  } catch {
    return { ...DEFAULT_PORTAL_UI_FLAGS };
  }
}

export function writePortalUiFlags(flags) {
  const normalized = normalizePortalUiFlags({
    ...readPortalUiFlags(),
    ...flags,
  });
  try {
    sessionStorage.setItem(PORTAL_UI_FLAGS_KEY, JSON.stringify(normalized));
  } catch {
    /* quota / private mode */
  }
  return normalized;
}

export function clearPortalUiFlags() {
  try {
    sessionStorage.removeItem(PORTAL_UI_FLAGS_KEY);
  } catch {
    /* ignore */
  }
}
